import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { AuthService } from './Core/services/auth.service';
import { LoginComponent } from './Features/auth/auth-module/Login/login.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})


export class AppComponent implements OnInit {
  isLoginPage: boolean =false;
  hideHeader: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router,private auth: AuthService) {
   
  }
  
  ngOnInit() {
    this.auth.share.subscribe(auth => {
      this.hideHeader = !auth;
     });
  }

  title = 'Kidde-Admin-Portal';
  
}

